import {MutationTree} from "vuex";
import EntryLink from "../ts/EntryLink";

export const mutations: MutationTree<any> = {

    setLoading(state: any, payload: boolean) {
        state.loading = payload;
    },

    setSaving(state: any, payload: boolean) {
        state.saving = payload;
    },

    setData(state: any, payload: Array<any>) {
        state.entryLinks = payload;
    },

    appendLink(state:any, payload: EntryLink) {
        state.entryLinks.push(payload);
    },

    updateLink(state:any, payload: EntryLink) {
        const index = state.entryLinks.findIndex((entryLink: EntryLink) => {
            return entryLink.id === payload.id;
        });

        state.entryLinks.splice(index, 1, payload);
    },

    deleteLink(state:any, payload: number) {
        const index = state.entryLinks.findIndex((entryLink: EntryLink) => {
            return entryLink.id === payload;
        });
        state.entryLinks.splice(index, 1);
    },

    clearCache(state: any) {
        state.expires = null;
    },
};
